import { assignInlineVars } from "@vanilla-extract/dynamic";
import cn from "classnames";
import React from "react";

import * as styles from "./ShimmerPlaceHolder.css";

interface ShimmerPlaceHolderProps {
  className?: string;
  $height?: number;
  $width?: number;
  $aspectRatio?: number;
  $backgroundColor?: string;
}

export const ShimmerPlaceHolder = ({
  className,
  $height,
  $width,
  $aspectRatio,
  $backgroundColor,
}: ShimmerPlaceHolderProps): JSX.Element => {
  return (
    <div
      className={cn(styles.shimmerPlaceholder, className)}
      style={assignInlineVars({
        [styles.varHeight]: $height ? `${$height}px` : "100%",
        [styles.varWidth]: $width ? `${$width}px` : "100%",
        [styles.varAspectRatio]: $aspectRatio ? `${$aspectRatio}` : "",
        [styles.varBackgroundColor]: $backgroundColor,
      })}
    />
  );
};
